import * as XLSX from 'xlsx'


export const BATCH_IMPORT_COLUMNS = [
    { key: 'empNo', header: 'Service No' },
    { key: 'amount', header: 'Amount' },
    // { key: 'percentage', header: 'Percentage (Optional override)' },
    // { key: 'overrideReason', header: 'Override Reason' },
    // { key: 'remarks', header: 'Remarks' },
];

export const downloadBatchEmployeeTemplate = (batchData) => {
  const wb = XLSX.utils.book_new();

  // Sample data row
  const sampleData = [
    {
      'Service No': '2400123',
      'Amount': batchData?.amount ?? 5000,
      // 'Percentage (Optional override)': batchData?.calculationMethod === 'Percentage' ? 10 : '',
      // 'Override Reason': 'Standard allocation',
      // 'Remarks': 'Added via template',
    },
  ];

  const ws = XLSX.utils.json_to_sheet(sampleData, {
    header: BATCH_IMPORT_COLUMNS.map((c) => c.header),
  });

  ws['!cols'] = [{ wch: 20 }, { wch: 16 }];

  XLSX.utils.book_append_sheet(wb, ws, 'BatchEmployees');
  XLSX.writeFile(wb, `Payroll_Batch_${batchData?.batchNo || 'Import'}_Template.xlsx`);
};


const norm = (s) => String(s).toLowerCase().replace(/\*/g, '').replace(/\s+/g, ' ').trim();

const pick = (row, test) => {
  const key = Object.keys(row).find((k) => test(norm(k)));
  return key !== undefined ? String(row[key] ?? '').trim() : '';
};

export const readBatchWorkbook = async (file) => {
  const buffer = await file.arrayBuffer();
  const wb = XLSX.read(buffer, { type: 'array' });
  const sheetName = wb.SheetNames.find((s) => /batchemp/i.test(s)) || wb.SheetNames[0];
  const ws = wb.Sheets[sheetName];

  if (!ws) return [];

  const rawRows = XLSX.utils.sheet_to_json(ws, { defval: '' });

  // return rawRows.map((row, idx) => {
  //   const getValue = (patterns) => {
  //     const foundKey = Object.keys(row).find((k) =>
  //       patterns.some((p) => k.toLowerCase().trim().includes(p.toLowerCase()))
  //     );
  //     return foundKey !== undefined ? String(row[foundKey]).trim() : '';
  //   };

  //   return {
  //       _row: idx + 2,
  //       empNo: String(row['Staff ID / Service No *'] ?? row['Staff ID / Service No'] ?? '').trim(),
  //       amount: String(row['Amount (Optional override)'] ?? row['Amount'] ?? '').trim(),
  //       percentage: String(row['Percentage (Optional override)'] ?? row['Percentage'] ?? '').trim(),
  //       overrideReason: String(row['Override Reason'] ?? row['Reason'] ?? '').trim(),
  //       remarks: String(row['Remarks'] ?? row['Remark'] ?? '').trim(),
  //   };
  // });

  return rawRows.map((row, idx) => {
    return {
      _row: idx + 2,
      empNo: String(
        row['Service No'] ?? 
        row['ServiceNo'] ?? 
        row['Staff ID / Service No *'] ?? 
        row['Staff ID / Service No'] ?? 
        ''
      ).trim(),
      amount: String(
        row['Amount'] ?? 
        row['Amount (Optional override)'] ?? 
        ''
      ).trim(),
    };
  })
};

export const validateBatchRow = (row, existingEmployeesMap, existingBatchEmpNos, duplicateInFileSet = new Set()) => {
  const errors = [];
  const empNo = String(row.empNo || '').trim();
  const lowerEmpNo = empNo.toLowerCase();

  if (!empNo) {
    errors.push('Service No is required');
  } else {
    // Check duplicates within Excel
    if (duplicateInFileSet.has(lowerEmpNo)) {
      errors.push(`Duplicate Service No "${empNo}" found multiple times in this Excel file`);
    }

    // Check existence in master employees
    const emp = existingEmployeesMap[lowerEmpNo];
    if (!emp) {
      errors.push(`Staff ID "${empNo}" does not exist in the employee system`);
    } else {
      // Check if employee is inactive
      const isActive = emp.HED_IS_ACTIVE === true || emp.HED_IS_ACTIVE === 'True' || emp.HED_IS_ACTIVE === 1 || emp.HED_IS_ACTIVE === '1';
      if (!isActive) {
        errors.push(`Employee "${empNo}" is inactive`);
      }
    }

    // Check existence in current batch
    if (existingBatchEmpNos.has(empNo.toLowerCase())) {
      errors.push(`Employee "${empNo}" is already added/active in this batch`);
    }
  }

  // Validate the amount is numeric
  const parsedAmount = row.amount ? Number(String(row.amount).replace(/,/g, '')) : undefined;
  if (row.amount && Number.isNaN(parsedAmount)) {
    errors.push(`Invalid amount value "${row.amount}"`)
  }

  const rawAmount = String(row.amount ?? '').replace(/,/g, '').trim();
  let amount;
  if (rawAmount !== '') {
    amount = Number(rawAmount);
    if (Number.isNaN(amount)) errors.push(`Amount "${row.amount}" is not a number`);
    else if (amount < 0) errors.push('Amount cannot be negative');
  }

  return {
    values: {
      ...row,
      empNo,
      amount: parsedAmount,
    },
    errors,
  };
};